// src/data/faqData.js

const FAQData = [
  {
    question: "What is your return policy?",
    answer: "You can return most items within 30 days of receipt for a full refund. Items must be in their original condition, unused, and in their original packaging. Some DIY kits with missing parts or damaged components may be subject to inspection before a refund is issued."
  },
  {
    question: "Do you offer international shipping?",
    answer: "Yes! We ship to select countries worldwide. Shipping costs and delivery times vary depending on your location and customs regulations. Please check our shipping page for estimated delivery times and international shipping fees."
  },
  {
    question: "How can I track my order?",
    answer: "Once your order has shipped, you will receive an email with a tracking number and a link to track its progress. You can also log in to your ModernForge account and check the 'My Orders' section for real-time updates on your shipment."
  },
  {
    question: "Can I change or cancel my order?",
    answer: "Orders can be modified or canceled within 2 hours of placing them. After this window, orders are processed immediately and may not be cancelable. For urgent changes, please contact our support team as soon as possible."
  },
  {
    question: "Do you offer discounts for bulk purchases?",
    answer: "Yes, we offer special pricing for bulk orders, especially for DIY kits for schools, clubs, or events. Contact our sales team with the quantity and products you’re interested in for a custom quote."
  },
  {
    question: "Do you have guides on how to build the kits?",
    answer: "Yes, we have video guides on our Youtube Channel that you can follow along to when building the DIY Kits. Keep in mind that each kit comes with its own instructions as well from its respective brand. "
  },
  {
    question: "How do I contact customer support?",
    answer: "You can reach our support team via email at support@modernforge.com or call us at (123) 456-7890 between 9 AM and 6 PM CST. We also provide a live chat option on our website for instant assistance."
  },
  {
    question: "How often do you restock items?",
    answer: "Popular DIY kits are restocked regularly. If an item is out of stock, you can sign up on the product page to receive email notifications as soon as it becomes available."
  }
];

export default FAQData;
